import axios, { AxiosResponse } from 'axios';

import { IPrehled } from 'services/akcionar/prehled';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export interface IPrehledUcastnik {
    offset: number;
    limit: number;
    count: number;
    order: string;
    zadosti: ISezZadostiUcastnik[];
}

export interface ISezZadostiUcastnik extends IPrehled {
    id: number;
    typudalosti: ETypUdalosti;
    tmp: string;
    nazevsouboru: string;
    datumzalozeni: string;
    elhlasovani: boolean;
    idhlasovani: number;
}

const prehledZpravy = (offset: number) => {
    return axios({
        method: 'GET',
        url: 'Ucastnik/Zpravy',
        params: {
            limit: 10,
            offset: offset
        }
    }).then((resp: AxiosResponse<IPrehledUcastnik>) => resp.data);
};

export default prehledZpravy;
